// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Rab","label":"e_Sab","image":"e_Tab","name":"e_Uab","description":"e_Vab","descriptionCollapsed":"e_Wab","bottomLine":"e_Xab","socialIcon":"e_Yab"};